import React, { createContext, useContext, useState } from 'react';
import LoadingOverlay from '../Components/LoadingOverlay';

// Create context
const LoadingOverlayContext = createContext();

// Create provider component
export const LoadingOverlayProvider = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);

  const showLoadingOverlay = () => setIsVisible(true);
  const hideLoadingOverlay = () => setIsVisible(false);

  return (
    <LoadingOverlayContext.Provider value={{ showLoadingOverlay, hideLoadingOverlay , isVisible }}>
      {children}
      {isVisible && <LoadingOverlay />}
    </LoadingOverlayContext.Provider>
  );
};

export const useLoadingOverlay = () => {
  const context = useContext(LoadingOverlayContext);
  if (!context) {
    throw new Error('useLoadingOverlay must be used within a LoadingOverlayProvider');
  }
  return context;
};
